import React, { Component } from 'react';
import { LayoutWithStepper } from 'layouts';
import { connect } from 'react-redux';
import { stepAction } from 'shared/store/actions';
import { FormattedHTMLMessage, injectIntl } from 'react-intl';
import selectors from 'shared/store/selectors';
import { PageContentWrapper } from 'components';

import CheckIcon from 'assets/icons/big-check.svg';

import './Confirmation.scss';

class Confirmation extends Component {
  componentDidMount() {
    this.props.onGetStepsProgress();
  }

  render() {
    const { intl: { formatMessage }, fullName } = this.props;
    return (
      <PageContentWrapper isWithPadding isWithHeader>
        <section className="page-container page-container--whiteBg">
          <section className="page-container__content confirmation">
            <h1 className="isPrimary">{formatMessage({ id: 'confirmation.thankyou' })}</h1>

            <article className="page-container__content__blueBg">
              <img src={CheckIcon} alt="Thank you!" />

              <p>{formatMessage({ id: 'confirmation.dearName' }, { name: fullName })}</p>
              <FormattedHTMLMessage id="confirmation.desc" />

              <br />
              <small>{formatMessage({ id: 'confirmation.notice' })}</small>
            </article>
          </section>
        </section>
      </PageContentWrapper>
    );
  }
}

const mapStateToProps = state => ({
  fullName: selectors.getFullName(state),
});

const mapDispatchToProps = dispatch => ({
  onGetStepsProgress: () => dispatch(stepAction.getProgress()),
});

export default connect(mapStateToProps, mapDispatchToProps)(LayoutWithStepper(injectIntl(Confirmation)));
